import { LNGS_NAMESPACE_MODULES } from '@ingenico/util-i18n-config';
import { CoreButton } from '@ingenico/react-ui/core-button';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ParameterModuleContentActionsContainer.module.scss';

export interface ParameterModuleContentActionsContainerProps {
  readonly onSave?: () => void;
  readonly onCancel?: () => void;
  readonly onClickViewChanges?: () => void;
  readonly viewChangesCount?: number;
  readonly isLoading?: boolean;
  readonly isValidForm?: boolean;
}

export function ParameterModuleContentActionsContainer({
  onSave,
  onCancel,
  onClickViewChanges,
  viewChangesCount = 0,
  isLoading,
  isValidForm = true,
}: ParameterModuleContentActionsContainerProps): ReactElement {
  const { t } = useTranslation([LNGS_NAMESPACE_MODULES.DEFAULT]);
  return (
    <div className={styles.container}>
      <CoreButton disabled={!viewChangesCount} variant="outlined" onClick={onClickViewChanges}>
        {`${t('button.viewChanges', { ns: LNGS_NAMESPACE_MODULES.DEFAULT })} (${viewChangesCount})`}
      </CoreButton>
      <div className={styles.saveButtonsContainer}>
        <CoreButton onClick={onCancel} variant="text" disabled={isLoading}>
          {t('button.cancel', { ns: LNGS_NAMESPACE_MODULES.COMMON })}
        </CoreButton>
        <CoreButton
          variant="contained"
          onClick={onSave}
          disabled={viewChangesCount === 0 || !isValidForm}
          loading={isLoading}
        >
          {t('button.save', { ns: LNGS_NAMESPACE_MODULES.COMMON })}
        </CoreButton>
      </div>
    </div>
  );
}
